"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationSubscription = void 0;
let NotificationSubscription = exports.NotificationSubscription = void 0;
(function (_NotificationSubscription) {
  let Area = /*#__PURE__*/function (Area) {
    Area["SITES"] = "Sites";
    Area["CAMPAIGNS"] = "Campaigns";
    Area["CONTACTS"] = "Contacts";
    Area["BILLING_AND_LEGAL"] = "Billing & Legal";
    Area["ORGANIZATION_AND_LEGAL"] = "Organization & Legal";
    return Area;
  }({});
  _NotificationSubscription.Area = Area;
})(NotificationSubscription || (exports.NotificationSubscription = NotificationSubscription = {}));